export default value => (value ? 'Aktiv' : 'Inaktivt');
